export const CONTAINER_TYPES = {
  CHASSI: 'chassi',
  SIMA: 'sima'
}
